export const MEDIA_ANALYSIS_EMPLOYER_BRANDING_META_DESCRIPTION =
  "Perceptica's employer branding analysis benchmarks your employer brand against the talent market - perception, themes and competitors. See the report.";
